import React from 'react';
import AppBar from '@mui/material/AppBar';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import NavMenu from '../NavMenu/NavMenu';
import useUser from '../../../hooks/useUser';
import regionConfig from '../../../config';

const StyledHeader = styled(AppBar)`
    background-color: #1d1d1d;

    .root {
        flex-grow: 1;
        display: flex;
    }

    .tabContainer {
        background-color: #171717;
    }

    .header {
        display: flex;
        padding: 0 1.5rem;
        flex-direction: column;

        @media (min-width: 600px) {
            justify-content: space-between;
            flex-direction: row;
        }
    }

    .headerLogin {
        display: flex;
        justify-content: center;
    }

    .heading {
        padding: 6px 12px;
        display: flex;
    }

    .logo {
        width: 220px;
        min-width: 130px;
    }

    // .headerRight {
    //     min-height: 64px;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;

    //     @media (min-width: 600px) {
    //         justify-content: flex-end;
    //     }
    // }

    // .navMenuBar {
    //     flex-direction: row;
    //     display: flex;
    // }

    // .navMenuItem {
    //     text-align: center;
    //     padding: 0.25rem 1.25rem;
    //     white-space: nowrap;
    //     cursor: pointer;
    // }

    // .active {
    //     background: green;
    //     color: #fff;
    //     border-radius: 0.3rem;
    // }

    .profileName {
        white-space: nowrap;
        margin-right: 0.5rem;
    }

    .profileImage {
        width: 30px;
        margin-right: 0.5rem;
    }

    .arrowDown {
        width: 20px;

        img {
            width: 20px;
        }
    }
`;

export interface HeaderProps {
    className?: string;
    isLoginScreen?: boolean;
    [props: string]: any;
}

const Header: React.FC<HeaderProps> = ({ className, isLoginScreen, ...props }) => {
    const user = useUser();

    return (
        <StyledHeader
            id="customer-dashboard-appbar"
            className={className}
            position="fixed"
            {...props}
            elevation={0}
        >
            <div
                id="customer-dashboard-container"
                className={isLoginScreen ? 'headerLogin' : 'header'}
            >
                <div id="customer-dashboard-heading-item">
                    {isLoginScreen ? (
                        <div style={{ paddingTop: '32px' }}>
                            <img src={regionConfig.HeaderLogo} alt="Convo Now" height={64} />
                        </div>
                    ) : (
                        <div id="customer-dashboard-heading" className="heading">
                            <Link to="/">
                                <img
                                    alt="sign live logo"
                                    id="customer-dashboard-img"
                                    src={regionConfig.logoSrc}
                                    className="logo"
                                />
                            </Link>
                        </div>
                    )}
                </div>
                {user && <NavMenu />}
            </div>
        </StyledHeader>
    );
};

export default Header;
